import styles from './Date.module.scss'
import moment from "moment";
import PropTypes from "prop-types";
import {ChangeEventHandler} from "react";

interface DateStructure {
  day?: number,
  month?: number,
  year?: number,
}

const stringToStructure = (input: string): DateStructure =>
{

  if (!input){
    return {}
  }
  const [year, month, day] = input.split('-')
  return {
    year: Number(year),
    month: Number(month),
    day: Number(day),
  };
}

const structureToString = (input: DateStructure): string =>
{
  const now = moment();
  let result = '';
  if (input.year){
    result = input.year.toString()
  }

  if (input.month){
    if (!input.year){
      result += now.year().toString()
    }
    result += '-' + input.month.toString().padStart(2, '0')
  }

  if (input.day){

    if (!input.year){
      result += now.year().toString()
    }
    if (!input.month){
      result += '-' + (now.month()+1).toString().padStart(2, '0')
    }
    result += '-' + input.day.toString().padStart(2, '0')
  }

  return result;
}
const Date = ({value: initValue, type = 'date', onChange}: {value: string, type?: string, onChange: (date: string) => void}) => {

  // const [date, setDate] = useState<string>('')
  const days = Array(31).fill(0)
  const localeData = moment().localeData();  // get language
  const months = localeData.months()
  const currentYear = moment().year();

  const value = stringToStructure(initValue);

  const renderYears = () => {
    const result = [];
    const isBirthDate = type === 'birthdate';
    const fromYear = isBirthDate ? 1900 : 1970
    for (let year = currentYear; year >= fromYear; year--) {
      result.push(<option key={year} value={year}>{year} {(year < 2006 && !isBirthDate) ? '*' : ''}</option>)
    }
    return result;
  }



  // ChangeEventHandler<HTMLSelectElement>
  const handleDayChange: ChangeEventHandler<HTMLSelectElement> = (e) => {

    let newDate = {...value}
    if (e.target.value){
      newDate.day = parseInt(e.target.value);
    } else {
      delete newDate.day
    }
    onChange(structureToString(newDate))
  }

  const handleMonthChange: ChangeEventHandler<HTMLSelectElement> = (e) => {


    let newDate = {...value}
    if (e.target.value){
      newDate.month = parseInt(e.target.value);
    } else {
      delete newDate.month
      delete newDate.day
    }
    onChange(structureToString(newDate))
  }

  const handleYearChange: ChangeEventHandler<HTMLSelectElement> = (e) => {
    let newDate = {...value}
    if (e.target.value){
      newDate.year = parseInt(e.target.value);
    } else {
      delete newDate.year
      delete newDate.month
      delete newDate.day
    }
    onChange(structureToString(newDate))
  }

  return <div className={styles.date}>
    <select className={styles.day} value={value?.day || ''} onChange={handleDayChange}>
      <option value="" disabled hidden>Dag</option>
      <option value="">Hele maand</option>
      {days.map((day, index) => (
        <option key={index} value={index + 1}>{index + 1}</option>
      ))}
    </select>
    <select className={styles.month} value={value?.month || ''} onChange={handleMonthChange}>
      <option value="" disabled hidden>Maand</option>
      <option value="">Hele jaar</option>
      {months.map((month, index) => (
        <option key={index} value={index + 1}>{month}</option>
      ))}
    </select>
    <select className={styles.year} value={value?.year || ''} onChange={handleYearChange}>
      <option value="" disabled hidden>Jaar</option>
      <option value=""></option>
      {renderYears()}
    </select>
  </div>
}


Date.propTypes = {
  type: PropTypes.oneOf(['date', 'birthdate']),
  onChange: PropTypes.func,
};


export default Date;
